// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__ItFJk","title":"BackImages_title__wWFpM","images":"BackImages_images__2NfPL"};